import { memo, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Tab } from '@/lib/v3/components';

interface BillingAndConsumptionTablesProps {
  consumptionTable: JSX.Element;
  billingTable: JSX.Element;
  legalBillingTable?: JSX.Element;
}

const BillingAndConsumptionTables = ({
  consumptionTable,
  billingTable,
  legalBillingTable,
}: BillingAndConsumptionTablesProps) => {
  const [currentTab, setCurrentTab] = useState(1);
  const { t } = useTranslation();

  const tabNavItems = useMemo(() => {
    const items = [
      <Tab.TabNavItem key={1} tabId={1} onClick={() => setCurrentTab(1)}>
        {t('MY_PLAN.TABS.consumption')}
      </Tab.TabNavItem>,
      <Tab.TabNavItem key={2} tabId={2} onClick={() => setCurrentTab(2)}>
        {t('MY_PLAN.TABS.billings')}
      </Tab.TabNavItem>,
    ];

    if (legalBillingTable) {
      items.push(
        <Tab.TabNavItem key={3} tabId={3} onClick={() => setCurrentTab(3)}>
          {t('MY_PLAN.TABS.legalBillings')}
        </Tab.TabNavItem>
      );
    }

    return items;
  }, [t, setCurrentTab, legalBillingTable]);

  const tabContentPanes = useMemo(() => {
    const panes = [
      <Tab.TabContentPane key={1} tabId={1}>
        <div className="mt-2">{consumptionTable}</div>
      </Tab.TabContentPane>,
      <Tab.TabContentPane key={2} tabId={2}>
        <div className="mt-2">{billingTable}</div>
      </Tab.TabContentPane>,
    ];

    if (legalBillingTable) {
      panes.push(
        <Tab.TabContentPane key={3} tabId={3}>
          <div className="mt-2">{legalBillingTable}</div>
        </Tab.TabContentPane>
      );
    }

    return panes;
  }, [consumptionTable, billingTable, legalBillingTable]);

  return (
    <div className="mt-4">
      <Card isAutoHeight id="billing-and-consumption-tables">
        <Card.Content withoutPadding>
          <div className="px-4">
            <Tab isUnderlined currentTab={currentTab}>
              <Tab.TabNav>{tabNavItems}</Tab.TabNav>
              <Tab.TabContent>{tabContentPanes}</Tab.TabContent>
            </Tab>
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};

export default memo(BillingAndConsumptionTables);
